import axios from "axios";

const getResource = (seriesId, skuId) => {
  const seriesIdParam = seriesId ? `seriesid=${seriesId}` : "";
  const skuIdParam = skuId ? `skuid=${skuId}` : "";
  const joinSeriesAndSku = seriesIdParam && skuIdParam ? "&" : "";

  const url = `/ignitionapi/ProductService/GetResources?${seriesIdParam}${joinSeriesAndSku}${skuIdParam}`;
  const config = {
    headers: { Pragma: "no-cache" }
  };
  
  return axios.get(url, config);
};

export default {
    getResource
};
